@if (onInit$ | async) {
  <div class="{{ wrapperClass }}">
    <div class="row">
      <div class="card">
        <app-dynamic-data-list-container [title]="title" [itemsSourceUrl]="sourceUrl" [itemsPerPage]="itemsPerPage"
          [pagination]="itemsPerPage" [cellProps]="tableProps" [tryToUseLazyLoadingPagination]="true"
          [useUrlParameters]="true" [tableSizeClass]="tableClass" [serverType]="serverType">
          @if (menuItems?.length > 0) {
            <app-dropdown-menu header [menuItems]="menuItems" [showSearch]="showSearch">
            </app-dropdown-menu>
          }
        </app-dynamic-data-list-container>
      </div>
    </div>
  </div>
}